<ngb-alert [type]="'warning'" (close)="closeNotice()" *ngIf="showNotice">
  <h3 i18n>Verify your profile setup</h3>
  <p i18n>To get the most out of OWL, make sure that you have configured Email settings, Contact emails and Default warehouse reservation fields.</p>
  <a *ngIf="!isInProfile" [routerLink]="['/profile']" i18n>Go to profile</a>
</ngb-alert>
